"use strict";

class PropertyDiscountsController {

    constructor(
        Upload,
        $timeout,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSAppService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.$timeout = $timeout;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD;
        self.DISCOUNT_TYPE_STAFF = SHOWSUITE.DISCOUNT_TYPE_STAFF;
        self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_OTHER = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_OTHER;
        self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;

        self.DISCOUNT_TYPE_REBATE = SHOWSUITE.DISCOUNT_TYPE_REBATE;
        self.DISCOUNT_TYPE_CASH_REBATE = SHOWSUITE.DISCOUNT_TYPE_CASH_REBATE;
        self.DISCOUNT_TYPE_VOUCHER = SHOWSUITE.DISCOUNT_TYPE_VOUCHER;
        self.DISCOUNT_TYPE_FURNITURE_FITTINGS = SHOWSUITE.DISCOUNT_TYPE_FURNITURE_FITTINGS;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.ROUNDING_METHOD_STANDARD = SHOWSUITE.ROUNDING_METHOD_STANDARD;
        self.ROUNDING_METHOD_FLOOR = SHOWSUITE.ROUNDING_METHOD_FLOOR;
        self.ROUNDING_METHOD_CEIL = SHOWSUITE.ROUNDING_METHOD_CEIL;

        self.ROUND_TO_ONE = SHOWSUITE.ROUND_TO_ONE;
        self.ROUND_TO_TEN = SHOWSUITE.ROUND_TO_TEN;
        self.ROUND_TO_HUNDRED = SHOWSUITE.ROUND_TO_HUNDRED;
        self.ROUND_TO_THOUSAND = SHOWSUITE.ROUND_TO_THOUSAND;

        self.DISCOUNT_CODE_STATUS_AVAILABLE = SHOWSUITE.DISCOUNT_CODE_STATUS_AVAILABLE;
        self.DISCOUNT_CODE_STATUS_USED = SHOWSUITE.DISCOUNT_CODE_STATUS_USED;

        self.DISCOUNT_CALCULATION_TYPE_ON_LIST_PRICE = SHOWSUITE.DISCOUNT_CALCULATION_TYPE_ON_LIST_PRICE;
        self.DISCOUNT_CALCULATION_TYPE_ON_NET_PRICE = SHOWSUITE.DISCOUNT_CALCULATION_TYPE_ON_NET_PRICE;
        self.DISCOUNT_CALCULATION_TYPE_ON_LAST_DISCOUNTED_PRICE = SHOWSUITE.DISCOUNT_CALCULATION_TYPE_ON_LAST_DISCOUNTED_PRICE;

        self.const_discount_dict = {
            10: "APPLY CALCULATION ON LIST PRICE",
            20: "APPLY CALCULATION ON NET PRICE",
            30: "APPLY CALCULATION ON LAST DISCOUNTED PRICE",
            "APPLY CALCULATION ON LIST PRICE": "LIST PRICE",
            "APPLY CALCULATION ON NET PRICE": "NET PRICE",
            "APPLY CALCULATION ON LAST DISCOUNTED PRICE": "DISCOUNTED PRICE"
        };

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.MARKETING_SCHEME_APPRECIATION_FEE = SHOWSUITE.MARKETING_SCHEME_APPRECIATION_FEE;
        self.MARKETING_SCHEME_BUYER_REFER_BUYER = SHOWSUITE.MARKETING_SCHEME_BUYER_REFER_BUYER;
        self.MARKETING_SCHEME_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_LOCAL_REFERRAL = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL;
        self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_STAFF_REFERRAL = SHOWSUITE.MARKETING_SCHEME_STAFF_REFERRAL;
        self.MARKETING_SCHEME_STAFF_PURCHASE = SHOWSUITE.MARKETING_SCHEME_STAFF_PURCHASE;
        self.MARKETING_SCHEME_EN_BLOC_PURCHASE = SHOWSUITE.MARKETING_SCHEME_EN_BLOC_PURCHASE;
        self.MARKETING_SCHEME_LARGE_UNITS = SHOWSUITE.MARKETING_SCHEME_LARGE_UNITS;
        self.MARKETING_SCHEME_VIP = SHOWSUITE.MARKETING_SCHEME_VIP;
        self.MARKETING_SCHEME_AGENT_PURCHASE = SHOWSUITE.MARKETING_SCHEME_AGENT_PURCHASE;

        self.MARKETING_SCHEMES = [
            {'id': self.MARKETING_SCHEME_APPRECIATION_FEE, 'name': 'Appreciation Fee'},
            {'id': self.MARKETING_SCHEME_BUYER_REFER_BUYER, 'name': 'Buyer-Refer-Buyer'},
            {'id': self.MARKETING_SCHEME_EXTERNAL_AGENT, 'name': 'External Agent'},
            {'id': self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY, 'name': 'Joint Marketing Agency'},
            {'id': self.MARKETING_SCHEME_LOCAL_REFERRAL, 'name': 'Local Referral'},
            {
                'id': self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Local Referral with Loyalty Buyer'
            },
            {'id': self.MARKETING_SCHEME_LOYALTY_BUYER, 'name': 'Loyalty Buyer'},
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT,
                'name': 'Loyalty Buyer with External Agent'
            },
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY,
                'name': 'Loyalty Buyer with Joint Marketing Agency'
            },
            {'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL, 'name': 'Overseas Referral'},
            {
                'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Overseas Referral with Loyalty Buyer'
            },
            {'id': self.MARKETING_SCHEME_STAFF_REFERRAL, 'name': 'Staff Referral'},
            {'id': self.MARKETING_SCHEME_STAFF_PURCHASE, 'name': 'Staff Purchase'},
            {'id': self.MARKETING_SCHEME_EN_BLOC_PURCHASE, 'name': 'En bloc Purchase'},
            {'id': self.MARKETING_SCHEME_LARGE_UNITS, 'name': 'Large units Purchase'},
            {'id': self.MARKETING_SCHEME_VIP, 'name': 'VIP Purchase'},
            {'id': self.MARKETING_SCHEME_AGENT_PURCHASE, 'name': 'Agent Purchase'},
        ];

        self.ROUNDING_METHODS = [
            {'id': self.ROUNDING_METHOD_STANDARD, 'name': 'Standard'},
            {'id': self.ROUNDING_METHOD_FLOOR, 'name': 'Floor'},
            {'id': self.ROUNDING_METHOD_CEIL, 'name': 'Ceil'}
        ];

        self.ROUND_TO_VALUES = [
            {'id': self.ROUND_TO_ONE, 'name': 'Round To One'},
            {'id': self.ROUND_TO_TEN, 'name': 'Round To Ten'},
            {'id': self.ROUND_TO_HUNDRED, 'name': 'Round To Hundred'},
            {'id': self.ROUND_TO_THOUSAND, 'name': 'Round To Thousand'}
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.propertyDiscounts = null;
        self.propertyDiscountsTotalCount = null;
        self.propertyDiscountsPagesCount = null;
        self.propertyDiscountsParams = {
            pageNo: '1',
            offset: 0,
            limit: '20',
            is_active: null,
            send_total_count: true,
            include: 'property_discount_codes, users'
        };

        self.sortColumn = "order";
        self.sortOrder = "asc";
        self.reverseSort = true;

        // self.selectedUnits = [];
        self.checked = 0;

        self.units = [];
        self.users = [];
        self.offset = 0;
        self.limit = 10;
        self.selected_units_count = self.limit;

        self.current = 1;
        self.jump_to_page = 1;

        self.pageChanged = function (newPage) {
            self.loadUnits(newPage);
        };

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.setPageOptions();

        self.selectedPropertyDiscount = null;
        self.propertyDiscountViewMode = null;
        self.propertyDiscountEditMode = null;
        self.propertyDiscountParams = null;

        self.propertyDiscountCodeGenerateMode = null;
        self.propertyDiscountCodeParams = null;

        self.getPropertyDiscounts();

        // jQuery('.datepicker').datepicker({
        //     changeMonth: true,
        //     changeYear: true,
        //     dateFormat: 'yy-mm-dd',
        //     showButtonPanel: true
        // });
    }

    //-------------------------------------------

    sortData(column) {
        const self = this;

        self.reverseSort = (self.sortColumn == column) ? !self.reverseSort : false;
        self.sortColumn = column;

        self.sortOrder = self.reverseSort ? "desc" : "asc";
        self.getPropertyDiscounts();
    }

    getSortClass(column) {
        const self = this;

        if (self.sortColumn == column) {
            return self.reverseSort ? 'fa-caret-down' : 'fa-caret-up';
        }
        return '';
    }

    getPropertyDiscounts() {
        let self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/discounts';

        self.propertyDiscountsParams.order = {};
        self.propertyDiscountsParams.order[self.sortColumn] = self.sortOrder;

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.propertyDiscountsParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.users = response.data.users;
            self.propertyDiscounts = response.data.property_discounts;
            self.propertyDiscountsTotalCount = response.data.total_count;

            //$.each(self.propertyDiscounts, function(index, discount){
            // discount.availability_start_date = self.getFormattedDate(discount.availability_start_date);
            // discount.availability_end_date = self.getFormattedDate(discount.availability_end_date);
            //});

            self.preparePropertyDiscountsPaginationData();
        });

        self.getUnits(self.data.property.id);
    }

    savePropertyDiscount(update_date = true) {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self._savePropertyDiscount(update_date);
        });
    }

    _savePropertyDiscount(update_date = true) {
        let self = this;

        self.SSAlertService.clear();

        if (!self.propertyDiscountParams) {
            return;
        }

        let url = 'sec/developer/properties/' + self.data.property.id + '/discounts';
        let params = angular.copy(self.propertyDiscountParams);

        // In case of unit selection, don't update other parameters
        if (update_date) {
            params.availability_start_date = self.getParamsDate(self.propertyDiscountParams.availability_start_date + " " + (self.availability_start_time ? self.availability_start_time : "00:00"));
            params.availability_end_date = self.getParamsDate(self.propertyDiscountParams.availability_end_date + " " + (self.availability_end_time ? self.availability_end_time : "00:00"));
        }

        // If 'order' is zero then set it to null
        if (params.order == 0) {
            params.order = null;
        }

        params.include = 'property_discount_codes';

        if (!params.combination_options) {
            params.combination_options = 'none';
        } else {
            if (params.combination_options[0] == 'all') {
                params.combination_options = 'all';
            } else if (params.combination_options[0] == 'none') {
                params.combination_options = 'none';
            } else {
                let index = params.combination_options.indexOf('none');
                if (index > -1) {
                    params.combination_options.splice(index, 1);
                }
                params.combination_options = params.combination_options.join(',');
            }
        }

        if (self.propertyDiscountUnitSelectionMode && self.checked > 0) {

            let unit_ids = '';

            $.each(self.units_master, function (index, unit) {
                if (self.checkboxes.items[unit.id] == true) {
                    if (index == 0) {
                        unit_ids += unit.id;
                    } else {
                        unit_ids += ',' + unit.id;
                    }
                }
            });
            params.unit_ids = unit_ids;
            self.selectedPropertyDiscount.total_selected_units = self.checked;
        }

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#propertyDiscountForm'))) {

            self.SSAlertService.danger("Please correct the following errors before you proceed.");

            // Check and display respective view
            if (self.propertyDiscountUnitSelectionMode) {
                self.propertyDiscountUnitSelectionMode = false;

                self.propertyDiscountViewMode = true;
                self.setPropertyDiscountEditMode(true);
            }

            return;
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let existingPropertyDiscount = self.selectedPropertyDiscount;
            let newPropertyDiscount = response.data.property_discount;

            if (existingPropertyDiscount && existingPropertyDiscount.id) {
                angular.merge(existingPropertyDiscount, newPropertyDiscount);
            } else {
                self.propertyDiscounts.push(newPropertyDiscount);
            }

            if (self.propertyDiscountUnitSelectionMode && self.checked > 0) {
                self.SSAlertService.success(self.checked + " units have been successfully tagged to this discount.");
            }

            self.propertyDiscountUnitSelectionMode = false;
            self.setPropertyDiscountViewMode(false);
            self.setPropertyDiscountViewMode(true, newPropertyDiscount);
        };

        loading(true);
        if (self.propertyDiscountParams.id) {
            url += '/' + self.propertyDiscountParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    importDiscounts(file) {
        const self = this;

        if (!file) {
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.data.property.id + '/discounts/import');

        loading(true);
        self.Upload.upload({
            url: url,
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Discounts imported successfully");
            self.getPropertyDiscounts();

        }, function (response) {
            loading(false);

            self.SSAlertService.parseAndDisplayError(response);
        });
    }

    exportDiscounts() {
        const self = this;

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.data.property.id + '/discounts/export');
        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Discounts exported successfully");
    }

    getValidity(discount) {
        const self = this;

        let validity = {validityStatus: '--', validityClass: ''};

        if (discount) {
            // Convert 'Start/End' dates to 'locale' date-time string for time comparison
            let start_date = self.formatUtcToLocalDate(discount.availability_start_date);
            let end_date = self.formatUtcToLocalDate(discount.availability_end_date);
            let today_date = moment(moment().format('YYYY-MM-DD HH:mm:ss'));

            // As the second parameter determines the precision, 
            // and not just a single value to check, using day will check for year, month and day.
            // If nothing is passed to moment#isBefore, it will default to the current time.
            // REFERENCE: https://momentjscom.readthedocs.io/en/latest/moment/05-query/01-is-before/

            if (start_date.isSameOrAfter(today_date, 'day') && end_date.isSameOrAfter(today_date, 'day')
                && start_date.diff(today_date, 'minutes') >= 0) {
                validity = {validityStatus: 'Up Coming', validityClass: 'text-primary'};
            } else if (end_date.isSameOrAfter(today_date, 'day') && today_date.isSameOrAfter(start_date, 'day')) {
                validity = {validityStatus: 'Valid', validityClass: 'text-success'};
            } else {
                validity = {validityStatus: 'Expired', validityClass: 'text-danger'};
            }
        }

        return validity;
    }

    formatUtcToLocalDate(date) {
        const self = this;

        try {
            if (typeof date === 'string') {
                // Convert 'date-time' string to UTC 'date-time' object
                var stillUtc = moment.utc(date).toDate();

                // Now convert UTC to local 'date-time' object
                var local = moment(moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss'));
            } else {
                local = date;
            }
        } catch (ex) {
            console.log(ex);
        }

        return local;
    }

    getParamsDate(dateString) {
        const self = this;

        // Empty value check
        if (dateString == null) return;
        dateString = dateString.trim();
        if (dateString === '') return;

        try {
            // Split date and time on the basis of white-space
            let datetime = dateString.split(" ");

            let date = datetime[0];
            let time = null;

            if (datetime.length > 1) {
                time = datetime[1];
                // Server accepts time as 'hh:mm:ss' but jQuery timepicker is 'hh:mm'
                if (time.split(':').length == 2) {
                    time = time + ':00';
                }
            }

            if (date.includes("/")) {
                let res = date.split("/", 3);
                date = res[2] + '-' + res[1] + '-' + res[0];
            }

            let formattedDate = date + (time ? ' ' + time : '');
            let dateTimeUTC = moment(formattedDate).utc().format('YYYY-MM-DD HH:mm:ss');

            return dateTimeUTC ? dateTimeUTC : null;
        } catch (ex) {
            console.log(ex);
        }
    }

    parseDate(date) {
        const self = this;

        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    getFormattedDate(date) {
        const self = this;

        try {
            if (date) {
                var local = self.UtctoLocal(date);

                return local;
            } else {
                return '--';
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    UtctoLocal(UTCDateString) {
        const self = this;

        var convertdLocalTime = new Date(UTCDateString);

        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;

        convertdLocalTime.setHours(convertdLocalTime.getHours() - hourOffset);

        var dateObj = new Date(convertdLocalTime);

        var _date = self.dateFormat(dateObj);

        return _date;
    }

    dateFormat(now) {
        const self = this;

        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
            month = "0" + month;
        }
        var day = "" + now.getDate();
        if (day.length == 1) {
            day = "0" + day;
        }
        var hour = "" + now.getHours();
        if (hour.length == 1) {
            hour = "0" + hour;
        }
        var minute = "" + now.getMinutes();
        if (minute.length == 1) {
            minute = "0" + minute;
        }
        var second = "" + now.getSeconds();
        if (second.length == 1) {
            second = "0" + second;
        }

        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    }

    deletePropertyDiscount(propertyDiscountId) {
        let self = this;

        if (!propertyDiscountId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.data.property.id + '/discounts/' + propertyDiscountId + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.code == 409 && response.message) {
                            self.SSAlertService.danger("Error!", response.message);
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    // Remove from local data
                    jQuery.each(self.propertyDiscounts, function (i, o) {
                        if (o.id == propertyDiscountId) {
                            self.propertyDiscounts.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

    getSelectedUnitsCount(propertyDiscount) {
        const self = this;

        if (!propertyDiscount) {
            return;
        }

        if (propertyDiscount.unit_ids) {
            try {
                let _unit_ids = propertyDiscount.unit_ids;
                if (_unit_ids.startsWith(',')) {
                    // When you use the replace method with a string rather than an RE, it just replaces the first match.
                    _unit_ids = _unit_ids.replace(',', '');
                }
                let unit_ids = _unit_ids.split(',');
                if (unit_ids.length > 0) {
                    return unit_ids.length;
                }
            } catch (ex) {
                console.log(ex);
            }
        } else {
            return '--';
        }
    }

    //-------------------------------------------

    getUnits(property_id) {
        const self = this;

        if (!property_id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];
        self.firstWatch = null;

        let url = 'sec/developer/properties/' + property_id + '/units';
        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.stacks;
            self.units = response.data.property_units;
            self.property_units = response.data.property_units;

            // Total units count for pagination
            self.count = response.data.property_units.length;

            jQuery.each(self.units, function (i, unit) {
                self.checkboxes.items[unit.id] = false;
                self.formatUnitData(unit);
            });

            self.units_master = angular.copy(self.units);

            self.loadUnits(undefined, self.units_master);
        });
    }

    getUnitName(unit_id) {
        const self = this;

        if (!unit_id || !self.property_units.length) {
            return;
        }

        let unit = self.property_units.find(x => x.id == unit_id);
        if (unit) {
            return "#" + unit.named_id;
        }

        return;
    }

    getUserName(user_id) {
        const self = this;

        let user_name = '';
        if (!user_id || !self.users.length) {
            return user_name;
        }

        let user = self.users.find(x => x.id == user_id);
        if (user) {
            user_name = user.display_name ? user.display_name : user.first_name + " " + user.last_name;
        }

        return user_name;
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units) {
        const self = this;

        if (page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if (!units) {
            units = self.units_master;
        }

        self.units = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if (parseInt(self.limit) < parseInt(self.units.length)) {
            self.selected_units_count = self.limit;
        } else {
            self.selected_units_count = self.units.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    saveSelectedUnits() {
        const self = this;

        if (self.checked > 0) {
            self.savePropertyDiscount(false);
        } else {
            self.SSAlertService.danger("Error!", "Please select units to proceed.");
        }
    }

    //---------------------------------

    generatePropertyDiscountCodes() {
        let self = this;

        if (!self.propertyDiscountCodeParams) {
            return;
        }

        let url = 'sec/developer/properties/' + self.data.property.id + '/discounts/' + self.selectedPropertyDiscount.id + '/codes/generate';
        let params = angular.copy(self.propertyDiscountCodeParams);

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#propertyDiscountCodeForm'))) {
            return;
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let existingPropertyDiscount = self.selectedPropertyDiscount;
            let newPropertyDiscount = response.data.property_discount;

            angular.merge(existingPropertyDiscount, newPropertyDiscount);

            self.setPropertyDiscountCodeGenerateMode(false);
        });
    }

    deletePropertyDiscountCode(propertyDiscountCodeId) {
        let self = this;

        if (!self.selectedPropertyDiscount || !propertyDiscountCodeId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.data.property.id + '/discounts/' + self.selectedPropertyDiscount.id + '/codes/' + propertyDiscountCodeId + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    // Remove from local data
                    if (self.selectedPropertyDiscount.property_discount_codes) {
                        jQuery.each(self.selectedPropertyDiscount.property_discount_codes, function (i, o) {
                            if (o.id == propertyDiscountCodeId) {
                                self.selectedPropertyDiscount.property_discount_codes.splice(i, 1);
                                return false;
                            }
                        });
                    }
                });
            }
        );
    }

    //-------------------------------------------

    preparePropertyDiscountsPaginationData() {
        const self = this;

        self.propertyDiscountsPagesCount = Math.ceil(self.propertyDiscountsTotalCount / self.propertyDiscountsParams.limit);

        self.propertyDiscountsPagesArray = [];
        for (let i = 0; i < self.propertyDiscountsPagesCount; i++) {
            self.propertyDiscountsPagesArray.push(i + 1);
        }

        if (self.propertyDiscountsPagesCount < self.propertyDiscountsParams.pageNo) {
            self.propertyDiscountsParams.pageNo = 1;
        }
    }

    formatDiscountValue(type, value) {
        const self = this;

        if (!(type || value)) {
            return '--';
        }

        let _value = value;

        if (type == self.VALUE_TYPE_PERCENTAGE) {
            _value = _value + ' %';
        } else if (type == self.VALUE_TYPE_AMOUNT) {
            _value = self.SSUtilService.formatCurrency(_value);
        }

        return _value;
    }

    parsePropertyDiscountCombinationOptions(options) {
        const self = this;

        if (!options) {
            return ['--'];
        }

        let _options = [];

        jQuery.each(options.split(','), function (i, v) {
            if (v == 'all') {
                _options.push('ALL');
            } else if (v == 'none') {
                _options.push('NONE');
            } else {
                _options.push(self.SSConfigService.getDiscountTypeCode(v));
            }
        });

        return _options.join(', ');
    }

    toggleActiveAndLoadPropertyDiscounts(isActive) {
        const self = this;

        if (isActive == true) {
            self.propertyDiscountsParams.is_active = self.propertyDiscountsParams.is_active != true ? true : null;
        }
        if (isActive == false) {
            self.propertyDiscountsParams.is_active = self.propertyDiscountsParams.is_active != false ? false : null;
        }

        self.getPropertyDiscounts();
    }

    setPageNoAndLoadPropertyDiscounts(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.propertyDiscountsParams.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.propertyDiscountsParams.pageNo - 1;
            }

            if (pageNo > self.propertyDiscountsPagesCount) {
                pageNo = self.propertyDiscountsPagesCount;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.propertyDiscountsParams.pageNo) {
                return; // Ignore if no change
            }

            self.propertyDiscountsParams.pageNo = pageNo;
        }

        self.propertyDiscountsParams.offset = (self.propertyDiscountsParams.pageNo - 1) * self.propertyDiscountsParams.limit;

        self.getPropertyDiscounts();
    }

    setLimitAndLoadPropertyDiscounts() {
        const self = this;

        self.propertyDiscountsParams.pageNo = '1';
        self.propertyDiscountsParams.offset = 0;

        self.getPropertyDiscounts();
    }

    parsePropertyDiscount(propertyDiscount) {
        const self = this;

        if (!propertyDiscount) {
            return;
        }

        if (propertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
            || propertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
            || propertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL
        ) {
            if (propertyDiscount.property_discount_codes
                && propertyDiscount.property_discount_codes.length
            ) {
                let propertyDiscountCode = propertyDiscount.property_discount_codes[0];

                propertyDiscount.code = propertyDiscountCode.code;
                propertyDiscount.total_no_of_uses = propertyDiscountCode.total_no_of_uses;
            }
        }

    }

    //-------------------------------------------

    isPropertyDiscountCodeAvailable(propertyDiscountCode) {
        if (!propertyDiscountCode)
            return;

        return propertyDiscountCode.total_no_of_uses > propertyDiscountCode.no_of_used_codes;
    }

    isFieldVisible(field) {
        const self = this;

        if (field == 'code') {
            return (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL);
        } else if (field == 'total_no_of_uses') {
            return (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL);
        } else if (field == 'no_of_used_codes') {
            return (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.selectedPropertyDiscount && self.selectedPropertyDiscount.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL);
        }
    }

    isFieldRequired(field) {
        const self = this;

        if (field = 'code') {
            return (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL);
        } else if (field = 'total_no_of_uses') {
            return (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER)
                || (self.propertyDiscountParams && self.propertyDiscountParams.type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL);
        }
    }

    //-------------------------------------------

    setPropertyDiscountViewMode(mode, propertyDiscount) {
        const self = this;

        self.total_selected_units = '--';

        if (mode) {

            self.checkAll = false;

            // If 'calculation_type' is null then set it to default value 10 of 'APPLY CALCULATION ON LIST PRICE'
            if (propertyDiscount && (propertyDiscount.calculation_type == null || propertyDiscount.calculation_type == 0)) {
                propertyDiscount.calculation_type = self.DISCOUNT_CALCULATION_TYPE_ON_LIST_PRICE;
            }

            self.selectedPropertyDiscount = propertyDiscount;
            self.total_selected_units = self.getSelectedUnitsCount(propertyDiscount);
            self.parsePropertyDiscount(propertyDiscount);

            if (!self.selectedPropertyDiscount) {
                self.setPropertyDiscountEditMode(mode);
            }
        } else {
            self.selectedPropertyDiscount = null;
            self.setPropertyDiscountEditMode(mode);
        }

        self.propertyDiscountViewMode = mode;
    }

    getLocaleDateTime(date_time) {
        const self = this;

        let parsed_date = '--';

        if (!date_time) {
            return parsed_date;
        }

        try {
            parsed_date = moment(moment.utc(date_time).toDate()).local().format('DD/MM/YYYY HH:mm:ss')
        } catch (ex) {
            console.log(ex);
        }

        return parsed_date;
    }

    setPropertyDiscountUnitSelectionMode(mode) {
        const self = this;

        if (mode) {
            if (self.selectedPropertyDiscount) {
                self.propertyDiscountParams = angular.copy(self.selectedPropertyDiscount);

                let unit_ids = self.propertyDiscountParams.unit_ids ? self.propertyDiscountParams.unit_ids.split(',') : [];

                if (unit_ids && unit_ids.length > 0) {

                    self.checked = 0;
                    self.checkboxes = {
                        checked: false,
                        count: 0,
                        items: {}
                    };

                    $.each(self.units_master, function (index, unit) {
                        if ($.inArray(unit.id.toString(), unit_ids) > -1) {
                            self.checkboxes.items[unit.id] = true;
                            self.checked += 1;
                        }
                    });
                }

                if (self.propertyDiscountParams.combination_options) {
                    self.propertyDiscountParams.combination_options = self.propertyDiscountParams.combination_options.split(',');
                }
            } else {
                self.propertyDiscountParams = {};
            }
            self.propertyDiscountViewMode = !mode;
            self.propertyDiscountEditMode = !mode;
            self.propertyDiscountCodeGenerateMode = !mode;
        } else {
            self.propertyDiscountParams = null;
            self.propertyDiscountViewMode = mode;
            self.propertyDiscountEditMode = mode;
            self.propertyDiscountCodeGenerateMode = mode;
        }

        self.propertyDiscountUnitSelectionMode = mode;
    }

    setPropertyDiscountEditMode(mode) {
        const self = this;

        self.availability_start_time = "";
        self.availability_end_time = "";

        if (mode) {
            if (self.selectedPropertyDiscount) {
                self.propertyDiscountParams = angular.copy(self.selectedPropertyDiscount);

                let start_date = self.propertyDiscountParams.availability_start_date;
                let end_date = self.propertyDiscountParams.availability_end_date;

                // Format Date Time to local string
                if (start_date) {
                    // self.propertyDiscountParams.availability_start_date = self.getLocaleDateTime(start_date);
                    self.propertyDiscountParams.availability_start_date = self.getLocaleDateTime(start_date);
                    self.availability_start_time = self.getTime(self.propertyDiscountParams.availability_start_date);
                    self.propertyDiscountParams.availability_start_date = self.propertyDiscountParams.availability_start_date.split(" ")[0];
                }
                if (end_date) {
                    // self.propertyDiscountParams.availability_end_date = self.getLocaleDateTime(end_date);
                    self.propertyDiscountParams.availability_end_date = self.getLocaleDateTime(end_date);
                    self.availability_end_time = self.getTime(self.propertyDiscountParams.availability_end_date);
                    self.propertyDiscountParams.availability_end_date = self.propertyDiscountParams.availability_end_date.split(" ")[0];
                }

                if (self.propertyDiscountParams.combination_options) {
                    self.propertyDiscountParams.combination_options = self.propertyDiscountParams.combination_options.split(',');
                }
            } else {
                self.propertyDiscountParams = {};
            }
        } else {
            self.propertyDiscountParams = null;
            if (!self.selectedPropertyDiscount) {
                self.propertyDiscountViewMode = mode;
            }
        }

        self.propertyDiscountEditMode = mode;
    }

    setPropertyDiscountCodeGenerateMode(mode) {
        const self = this;

        self.propertyDiscountCodeGenerateMode = !self.propertyDiscountCodeGenerateMode;

        if (mode) {
            self.propertyDiscountCodeParams = {
                include: 'property_discount_codes'
            };
        }
    }

    getTime(dateTime) {

        if (!dateTime) return;

        let time = null;
        let arr = dateTime.split(" ");

        if (arr.length > 1) {
            time = arr[1];
            time = time.split(":")[0] + ":" + time.split(":")[1];
        }

        return time;
    }

    //-------------------------------------------

    getMarketingSchemeName(id) {
        const self = this;
        let name = null;

        $.each(self.MARKETING_SCHEMES, function (i, marketingScheme) {
            if (marketingScheme.id == id) {
                name = marketingScheme.name;
                return false;
            }
        });

        return name;
    }

    //-------------------------------------------

    applySearch() {
        const self = this;

        var units = self.units_master;
        var page = 0;

        if (self.isSearchApplied()) {
            self.offset = 0;
            page = 1;

            units = self.getFilteredUnits();
        }

        self.loadUnits(page ? page : undefined, units);

        // Re-Assign CheckAll filter
        // self.toggleCheckAll();
    }

    isSearchApplied() {
        const self = this;

        if (!self.block_no_search && !self.unit_no_search && !self.category_search && !self.floor_plan_type_search
            && !self.name_search && !self.price_type_search && !self.price_search && !self.psf_search) {

            return false;
        } else {
            return true;
        }
    }

    getFilteredUnits() {
        const self = this;

        let units = [];

        _.each(self.units_master, function (unit) {
            if (unit.block_no && self.block_no_search && unit.block_no.toString().includes(self.block_no_search)) {
                units.push(unit);
            }
            if (unit.named_id && self.unit_no_search && unit.named_id.includes(self.unit_no_search)) {
                units.push(unit);
            }
            if (unit.formatted_category && self.category_search && unit.formatted_category.trim().toLowerCase().includes(self.category_search.trim().toLowerCase())) {
                units.push(unit);
            }
            if (unit.formatted_floor_plan_type && self.floor_plan_type_search && unit.formatted_floor_plan_type.trim().toLowerCase().includes(self.floor_plan_type_search.trim().toLowerCase())) {
                units.push(unit);
            }
            if (unit.name && self.name_search && unit.name.trim().toLowerCase().includes(self.name_search.trim().toLowerCase())) {
                units.push(unit);
            }
            if (unit.formatted_price_type && self.price_type_search && unit.formatted_price_type.trim().toLowerCase().includes(self.price_type_search.trim().toLowerCase())) {
                units.push(unit);
            }
            if (unit.price && self.price_search && unit.price.toString().includes(self.price_search)) {
                units.push(unit);
            }
            if (unit.psf && self.psf_search && unit.psf.toString().includes(self.psf_search)) {
                units.push(unit);
            }
        });

        return units;
    }

    // Statuses: ALL, LISTED, DRAFT, BOOKED etc
    filterUnitsByStatus(status) {
        const self = this;

        self.unit_status = status;

        if (!status) {
            self.loadUnits(undefined, self.units_master);
            return;
        }

        let units = [];

        jQuery.each(self.units_master, function (index, unit) {
            if (unit.status == status) {
                units.push(unit);
            }
        });

        // params: self.loadUnits(pageNum, filtered/sorted units);
        self.loadUnits(undefined, units);
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.actual_price = unit.price;

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    /**
     * Select or clear every (filtered) unit row to match the Select All checkbox.
     *
     * Must be wired in the view via ng-model="ctrl.checkAll" + ng-change — never ng-click:
     * on checkboxes ng-click fires before ngModel writes the new state, so self.checkAll
     * would still hold the previous value and the toggle behaves inverted. The previous
     * re-read of the deprecated global `event.target.checked` is no longer needed (WEB-3556).
     *
     * @returns {void}
     */
    toggleCheckAll() {
        const self = this;

        self.checked = 0;

        // Uncheck all to apply new changes
        jQuery.each(self.units_master, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
            self.edited_status = "";
        });

        let units = self.units_master;

        if (self.isSearchApplied()) {
            units = self.getFilteredUnits();
        }

        if (self.checkAll) {
            // All units checked
            jQuery.each(units, function (index, unit) {
                self.checkboxes.items[unit.id] = true;
                self.checked += 1;
            });
        }
    }

    checkedAlert(unit) {
        const self = this;

        if (self.checkboxes.items[unit.id] == false) {
            self.checkboxes.items[unit.id] == true;
            self.checked -= 1;
        } else if (self.checkboxes.items[unit.id] == true) {
            self.checkboxes.items[unit.id] == false;
            self.checked += 1;
        }
    }

    goBack() {
        const self = this;

        self.$window.location.href = '/developer/properties/' + self.property.named_id + '/discounts';
    }

    setPageOptions() {
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES) {
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for (var index = 0; index < TOTAL_PAGES; index++) {
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString()});
        }
    }
}

PropertyDiscountsController.$inject = [
    'Upload',
    '$timeout',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSAppService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('PropertyDiscountsController', PropertyDiscountsController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.

// app.directive("timepicker", function () {

//     function link(scope, element, attrs) {
//         // CALL THE "timepicker()" METHOD USING THE "element" OBJECT.
//         element.timepicker();
//     }

//     return {
//         require: 'ngModel',
//         link: link
//     };
// });
